export enum SortKeys {
  PUBLISH_DATE = "publishDate",
  NAME = "title",
  INVESTOR_ACCOUNT = "investorAccountName",
  FUND = "fundDisplayName",
}
